import { ISelectOption } from '../../../ui-toolkit';

export enum eDepositCategory {
  earnest_money_deposit = 'earnest_money_deposit',
  cash_to_close = 'cash_to_close',
  lender_money = 'lender_money',
  tax_authority = 'tax_authority',
  return = 'return',
  other = 'other',
  option_fee = 'option_fee',
}

export const prettyDepositCategory: Record<eDepositCategory, string> = {
  [eDepositCategory.earnest_money_deposit]: 'Earnest Money Deposit',
  [eDepositCategory.cash_to_close]: 'Cash To Close',
  [eDepositCategory.lender_money]: 'Lender Money',
  [eDepositCategory.tax_authority]: 'Tax Authority',
  [eDepositCategory.return]: 'Return',
  [eDepositCategory.other]: 'Other',
  [eDepositCategory.option_fee]: 'Option Fee',
};

export const depositCategoryOptions: ISelectOption[] = Object.values(eDepositCategory).map((category) => ({
  label: prettyDepositCategory[category],
  value: category,
}));
